
import AppInput from '@/uikit/components/AppInput/AppInput.vue';
import AppButtonNew from '@/uikit/components/AppButtonNew/AppButtonNew.vue';
import { ButtonType } from '@/uikit/components/AppButtonNew/defaultConfigs';

export default {
  name: 'RegisterAuthModal',
  computed: {
    ButtonType() {
      return ButtonType;
    },
  },
  components: { AppButtonNew, AppInput },
  methods: {
    buttonAuthClick() {
      this.$store.state.modalCallBack('entrance');
    },
    buttonRegisterClick() {
      this.$store.state.modalCallBack('registration');
    },
  },
};



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/parts/modules/register_auth_modal/RegisterAuthModal.vue